<template>
  <div id="app">
    <router-view />
    <toTop></toTop>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./assets/reset.css";
body{
  background-color: #ffffff;
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media screen {
  html {
    font-size: 9px;
  }
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 576px) {
  html {
    font-size: 10px;
  }
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  html {
    font-size: 12px;
  }
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  html {
    font-size: 14px;
  }
  .container {
    max-width: 960px;
  }
}

@media screen and (min-width: 1200px) {
  html {
    font-size: 16px;
  }
  .container {
    max-width: 1145px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?76dfaa95